// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import Button from './button';

// Styles
import './sort-title-button.scss';

export default class SortTitleButton extends Component {
    getClass() {
        const {className, disabled} = this.props;

        return classnames(
            {
                'sort-title-button': true,
                'sort-title-button_disabled': disabled,
            },
            className
        );
    }

    getIcon() {
        const {sortType} = this.props;
        let icon = 'sort';

        if (sortType) {
            icon += `-${sortType}`;
        }

        return icon;
    }

    getProps() {
        const {dataKey, disabled, maxWidth, title, width} = this.props;

        return {
            className: this.getClass(),
            disabled,
            icon: !disabled ? this.getIcon() : null,
            onClick: this.handleClick,
            style: {maxWidth, width},
            title,
            type: 'tableTitle',
            value: dataKey,
        };
    }

    handleClick = () => {
        const {disabled, onClick, sortKey} = this.props;

        if (!disabled) {
            onClick(sortKey);
        }
    };

    render() {
        const {children} = this.props;

        return <Button {...this.getProps()}>{children}</Button>;
    }
}

SortTitleButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    dataKey: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    sortKey: PropTypes.string,
    sortType: PropTypes.string,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
